import React, { Component } from "react";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import { isFunction, forEach, toArray } from "lodash";
import { Switch, Route, Redirect } from "react-router-dom";
import classNames from "classnames";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import LinearProgress from "@material-ui/core/LinearProgress";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { withStyles } from "@material-ui/core/styles";
import Nav from "../Nav";
import Schemas from "../modules/Schemas";
import Content from "../modules/Content";
import Admin from "../modules/Admin";
import schemas from "../modules/Content/content-types";
import firebase from "../../config/firebase";
import { navOpenWidth } from "../../config/constants";
import { getSubscriptions, createSubscription } from "../../utils/db";
import FileManager from "../FileManager";
import logo from "../../assets/img/_logo.png";

import "./App.css";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    height: "100vh",
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },

  logo: {
    width: "128px",
    marginTop: -4,
  },

  logoSpaced: {
    marginLeft: theme.spacing(3),
  },

  searchField: {
    marginRight: theme.spacing(2),
  },

  backButtonHolder: {
    marginRight: theme.spacing(2),
  },

  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  mainHeader: {
    background: "rgba(0, 0, 0, 1)",
  },

  appBarShift: {
    marginLeft: navOpenWidth,
    width: `calc(100% - ${navOpenWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  menuButton: {
    margin: "0 20px",
  },

  hide: {
    display: "none",
  },

  flex: {
    flex: 1,
  },

  main: {
    position: "relative",
    height: "100vh",
    maxHeight: "100vh",
    overflow: "auto",
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
  },

  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    minHeight: 54,
  },

  content: {
    padding: theme.spacing(4),
  },

  sticky: {
    position: "sticky",
    top: 54,
    zIndex: 10,
  },
});

class App extends Component {
  state = {
    navOpen: false,
  };

  componentDidMount() {
    // Check for user auth state change and redirect
    firebase.auth.onAuthStateChanged((user) => {
      if (!user) {
        this.props.history.push("/login");
      } else {
        // TODO : remove this, issue is relational data fetching and table updates
        forEach(toArray(schemas), (schema) => {
          createSubscription(schema.ref);
        });
      }
    });
  }

  componentWillUnmount() {
    forEach(getSubscriptions(), (fn, key) => {
      console.info(`Unsubscribed from ${key}`);
      if (isFunction(fn)) {
        fn();
      }
    });
  }

  toggleNav = () => {
    this.setState({ navOpen: !this.state.navOpen });
  };

  showNav = () => {
    // return this.props.location.pathname !== '/dashboard';
    return true;
  };

  render() {
    const { classes } = this.props;
    const { navOpen } = this.state;

    return (
      <div className={classes.root}>
        <AppBar position="absolute" className={classNames(classes.appBar)}>
          <Toolbar
            variant="dense"
            disableGutters
            className={classes.mainHeader}
          >
            {this.showNav() && (
              <IconButton
                color="inherit"
                aria-label="navOpen drawer"
                onClick={this.toggleNav}
                className={classNames(classes.menuButton)}
              >
                {!navOpen ? <MenuIcon /> : <ChevronLeftIcon />}
              </IconButton>
            )}
            <img
              src={logo}
              alt="CMS"
              className={classNames(
                classes.logo,
                !this.showNav() && classes.logoSpaced
              )}
            />
          </Toolbar>
        </AppBar>

        {this.showNav() && <Nav isOpen={navOpen} toggleNav={this.toggleNav} />}

        <main className={classes.main}>
          <div className={classes.toolbar} />
          {/* <Toolbar variant="dense" className={classes.sticky}>
            <div className={classes.backButtonHolder}>
              <IconButton
                color="secondary"
                onClick={() => this.props.history.goBack()}
              >
                <ChevronLeftIcon />
              </IconButton>
            </div>

            <Typography
              variant="subtitle1"
              color="inherit"
              className={classes.flex}
            >
              {this.props.location.pathname}
            </Typography>
            <DarkTheme>
              <TextField
                id="search"
                name={`${Date.now()}`}
                margin="dense"
                className={classes.searchField}
                placeholder="Search"
                type="search"
              />
            </DarkTheme>
            <Button variant="contained" color="primary">
              Save
            </Button>
          </Toolbar> */}
          {this.props.loading && <LinearProgress />}
          <FileManager />
          <Switch>
            <Route path="/edit" component={Content} />
            <Route path="/schemas" component={Schemas} />
            <Route path="/admin" component={Admin} />
            <Redirect from="/" to="/edit" />
          </Switch>
        </main>
      </div>
    );
  }
}

export default connect(
  ({ appState }) => ({
    loading: appState.loading,
  }),
  {}
)(withStyles(styles)(hot(module)(App)));
